export default "__VITE_ASSET__B6u0Km3m__"